import { IComment, ICommentContent } from "interfaces/comment";
import { useWriteComment } from "../useWriteComment";

interface Result {
  createCaseActionComment: (content: ICommentContent) => Promise<IComment>;
  updateCaseActionComment: (
    commentId: number,
    content: ICommentContent
  ) => Promise<IComment>;
  deleteCaseActionComment: (commentId: number) => Promise<void>;
}

export function useWriteCaseActionComment(
  caseActionId: number,
  onCommentsChanged: () => void
): Result {
  const { createComment, updateComment, deleteComment } = useWriteComment(
    `case_actions/${caseActionId}`,
    onCommentsChanged
  );

  return {
    createCaseActionComment: createComment,
    updateCaseActionComment: updateComment,
    deleteCaseActionComment: deleteComment
  };
}
